export default __webpack_public_path__ + "static/media/gallery28.8a1853f4.jpg";